/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface ITextPlaceholderFunctionScope extends angular.IScope {
        mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        mapFunctionConfiguration: Wars.Domain.Model.Gis.MapFunctionConfiguration;
        go:any;
        textValue:string;
    }

    export class TextPlaceHolderFunction implements IDirective {
        constructor() {

        }

        public templateUrl = "./app/views/directives/gis/mapFunction/textPlaceHolderFunction.html";
        public restrict: string = "E";
        public controller = ["$scope", "$rootScope",TextPlaceHolderFunctionController];
        public controllerAs = "controller";
        public scope: any = {
            mapConfiguration: "=",
            mapFunctionConfiguration: "="
        };

        public link($scope: ITextPlaceholderFunctionScope, element: JQuery, attrs: ng.IAttributes) {

        }
    }

    export class TextPlaceHolderFunctionController {

        constructor(private $scope: ITextPlaceholderFunctionScope,private $rootScope:angular.IRootScopeService) {
            this.$scope.go = () => this.go();
        }

        private go() {
            this.$rootScope.$broadcast(this.$scope.mapFunctionConfiguration.id,{textValue:this.$scope.textValue});
        }

    }
}

warsApp.registerDirective('TextPlaceHolderFunction', []);